"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "savignano-sul-panaro": {
    "77de8567": [{
      "hkey": "1ab9b5ff",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "castello-di-savignano-sul-panaro": [{
      "hkey": "1ab9b5ff",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "savignano-sul-panaro"
    }],
    "f179d6d9": [{
      "hkey": "1ab9b5ff",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "doccia": [{
      "hkey": "1ab9b5ff",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "savignano-sul-panaro"
    }],
    "97065a7d": [{
      "hkey": "b49b4069",
      "slug": "formica",
      "name": "Formica",
      "primary": true,
      "skipSearch": false
    }],
    "formiche": [{
      "hkey": "b49b4069",
      "slug": "formica",
      "name": "Formica",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;